import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import Select from 'react-select'
import './Establecimiento.css';
import useColumnsEstablcm from "../../hooks/useColumnsEstablcm";
import { AuthenticationService } from '../../services/authentication.service';
import * as Constants from '../../constants';
import PopUpEstablecimiento from './NuevoEstablecimiento';
import EstablecimientoService from '../../services/establecimiento.service';
import Table from './TableEstablecimientos';
import { FaFilter } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";

import { FaPlus } from "react-icons/fa";
import NavBar from '../NavBar/NavBar';
import CadenaService from '../../services/cadena.service';
import PopUpDesactivaEstablecimiento from './DesactivarEstablecimiento';
import toast, { Toaster } from 'react-hot-toast';
import { useEstablishment } from '../../Context/EstablishmentContext';


const Establecimiento = () => {
	const { establecimiento, setEstablecimiento } = useEstablishment();
	const [seen, setSeen] = useState(false);
	const [seenDesactivaPopup, setSeenDesactivaPopup] = useState(false);
	const [t] = useTranslation("global");

	const authenticationService = new AuthenticationService();
	const tipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;//obtiene el tipo de trabajador
	const userRol = authenticationService.getAuthenticationSession().user.idTipo;//obtiene el rol de usuario
	const userCadena = authenticationService.getAuthenticationSession().user.cadena;

	const navigate = useNavigate();

	const [listaEstablecimientos, setListaEstablecimientos] = useState([]);
	const [listaCadenas, setListaCadenas] = useState([]);
	const [selectedEstablecimiento, setSelectedEstablecimiento] = useState(null);

	const [filtroNombre, setFiltroNombre] = useState('');
	const [filtroActivo, setFiltroActivo] = useState(1);
	const [filtroCadena, setFiltroCadena] = useState(null);
	
	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));
	
	const [muestraBtnDesactivar, setMuestraBtnDesactivar] = useState(true);
	const [esUsuarioGestor, setEsUsuarioGestor] = useState(false);

	//		const toastLoading = toast.loading(t('app.mensaje.loading'));
	//		const toastErrorLogin = () => toast.error(t('app.error.login.fail'));
	//		const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));

	useEffect(() => {
		const authentication = authenticationService.getAuthenticationSession();

		if (authentication === null) {
			navigate(Constants.ROUTE_ROOT);
		} else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_ADMINISTRADOR) {
				obtenerListaEstablecimientos();
				obtenerListaCadenas();
		}else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_ADMIN_CADENA) {
				obtenerListaEstablecimientosByCadena(authenticationService.getAuthenticationSession().user.cadena.id);
		}else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_GESTOR) {
				setEsUsuarioGestor(true);
				obtenerEstablecimientoById(authentication.user.establecimiento);
		}
			
		
	}, [navigate]);

	function togglePop() {

		if (selectedEstablecimiento != null) {
			setSelectedEstablecimiento(null);
		}

		setSeen(!seen);
	}
	
	function togglePopDesactiva() {

		/*if (selectedEstablecimiento != null) {
			setSelectedEstablecimiento(null);
		}*/

		setSeenDesactivaPopup(!seenDesactivaPopup);
	}

	function guardarSelectedEstablecimiento(establecimiento) {
		setSelectedEstablecimiento(establecimiento);
	}
	
	function eliminarSelectedEstablecimiento(establecimiento) {
		setSelectedEstablecimiento(establecimiento);
		
	}
	
	const desactivaEstablecimiento = async () => {
		
		await EstablecimientoService.desactivarEstablecimiento(selectedEstablecimiento.id)
			.then((response) => {
				if (response.status === 200) {
					
					togglePopDesactiva();
					setSelectedEstablecimiento(null);
					obtenerListaEstablecimientos();
				} else {
					toastGenericErrorLogin();
				}
				
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
		
	}

	const obtenerListaCadenas = async () => {
		await CadenaService.getCadenas()
			.then(response => response.json())
			.then(data => setListaCadenas(data));
	}

	const obtenerListaEstablecimientos = async () => {
		await EstablecimientoService.getEstablecimientos()
			.then(response => response.json())
			.then(data => {
				setListaEstablecimientos(data);
				setEstablecimiento(data[0]);
				});
	}


	const obtenerListaEstablecimientosByParams = async (nombre, activo, cadena) => {
		await EstablecimientoService.getEstablecimientosByParams(nombre, activo, cadena)
			.then(response => response.json())
			.then(data => setListaEstablecimientos(data));
	}
	
	const obtenerEstablecimientoById = async (id) => {
		await EstablecimientoService.getEstablecimientoById(id)
			.then(response => response.json())
			.then(data => setListaEstablecimientos(new Array(1).fill(data)));
	}
	
	const obtenerListaEstablecimientosByCadena = async (cadena) => {
		await EstablecimientoService.getEstablecimientosByParams('', 1, cadena)
			.then(response => response.json())
			.then(data => {
				setListaEstablecimientos(data);
				setEstablecimiento(data[0]);
				setFiltroCadena(cadena);
				});
	}

	const optionsActivo = [
		{ value: 1, label: t('app.label.si') },
		{ value: 0, label: t('app.label.no') }
	];

	const onChangeFiltroActivo = (ev) => {
		setFiltroActivo(ev.value);
		obtenerListaEstablecimientosByParams(filtroNombre, ev.value, filtroCadena);
		
		ocultarOMostrarBtnDesactivar(ev.value);
	}
	
	function ocultarOMostrarBtnDesactivar (value) {
		if(value == 1) {
			setMuestraBtnDesactivar(true);
		} else {
			setMuestraBtnDesactivar(false);
		}
	}

	const onChangeFiltroNombre = (ev) => {
		setFiltroNombre(ev.target.value)
		obtenerListaEstablecimientosByParams(ev.target.value, filtroActivo, filtroCadena);
	}

	const onChangeFiltroCadena = (ev) => {
		setFiltroCadena(ev.id)
		obtenerListaEstablecimientosByParams(filtroNombre, filtroActivo, ev.id);
	}



	const limpiarFiltros = () => {
		setFiltroNombre('');
		setFiltroCadena('');
		setFiltroActivo(1);
		ocultarOMostrarBtnDesactivar(1);
		if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_ADMINISTRADOR) {
				obtenerListaEstablecimientos();
		}else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_ADMIN_CADENA) {
				obtenerListaEstablecimientosByCadena(authenticationService.getAuthenticationSession().user.cadena.id);
		}else if(authenticationService.getAuthenticationSession().user.idTipo === Constants.ROLE_USUARIO_GESTOR) {
				obtenerEstablecimientoById(authenticationService.getAuthenticationSession().user.establecimiento);
		}
	}
	
	
	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
}




	return (
		<main className="mainContainerPage">
			<section className="principal-container">

				<div className={'container-crearComponente'}>
					<h1 className={'title-Componente'}>{t("app.establecimiento.datosEstablecimiento")}</h1>
				
					{(userRol === Constants.ROLE_USUARIO_GESTOR) ? null : (
					<button className={'btn-general'} onClick={togglePop}><FaPlus size="10"/> <p className="txt-btn-nuevoCompt">{t("app.establecimiento.nuevoEstablecimiento")}</p></button>
					)}
					
					{seen ? <PopUpEstablecimiento toggle={togglePop}
						loadEstablecimientos={obtenerListaEstablecimientos}
						loadEstablecimientosByParams={obtenerListaEstablecimientosByParams}
						filtroActivo={filtroActivo}
						filtroCadena= {filtroCadena}
						filtroNombre = {filtroNombre}
						limpiarFiltros={limpiarFiltros}
						selectedEstablecimiento={selectedEstablecimiento}
						userRol={userRol}
						userCadena={userCadena}
						 /> : null}
						
					{seenDesactivaPopup ? <PopUpDesactivaEstablecimiento desactivaEstablecimiento={desactivaEstablecimiento} toggle={togglePopDesactiva} /> : null}
					
				</div>


			<div className="container-filtro-tabla">
			
			{(esUsuarioGestor) ? null :
			
			<div className="container-filtro-Establ">
					<div className="div_img-filtroInputText">
						<IoSearch className="iconSearch" size="20" />
						<input placeholder={t("app.placeholder.buscarEstablecimiento")} type="search"
								className={'filtroInputText'}
								value={filtroNombre}
								onChange={onChangeFiltroNombre} />
					</div>
					
				
					<div className="container-selects-btn-limpiarFiltro-Establ">
						<div className={'filterItem'}>
							<label className={'fieldsetLabel'}>{t("app.popup.label.activo")}</label>
							<Select
								className={'filtroSelect'}
								defaultValue={optionsActivo[0]}
								value={optionsActivo.find(e => e.value === filtroActivo)}
								options={optionsActivo}
								onChange={option => onChangeFiltroActivo(option)}
								isSearchable={false}
								styles={colorFiltros}
							/>
						</div>
						
							 <button className={'btn-limpiarFiltro'} onClick={() => { limpiarFiltros(); }}><FaFilter /> <p className="txt-btn-limpiarFiltro">{t("app.cama.limpiarFiltros")}</p></button>
						
					</div>
				</div>
				}
				<div className="containerTabla">
				<Table columns={useColumnsEstablcm(esUsuarioGestor, muestraBtnDesactivar, togglePop, togglePopDesactiva, guardarSelectedEstablecimiento, eliminarSelectedEstablecimiento)} data={listaEstablecimientos} />
				</div>

			</div>
			
			</section>
		</main>
	);
}

export default Establecimiento